export class DateUtil {
    /**
     * Checks if two dates are on the same date (not including hours, minutes, ...)
     * @example
     * sameDay(new Date(), new Date()) => true
     * @returns If the two dates are on the same date.
     */
    static sameDay(d1: Date, d2: Date) {
        return d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate();
    }
    /**
     * Checks if the first date is within the second date.
     */
    static dateIsInRange(firstStartDate: Date, firstEndDate: Date, secondStartDate: Date, secondEndDate: Date): boolean {
        return (firstStartDate >= secondStartDate && firstEndDate <= secondEndDate);
    }
    /**
     * Checks if the dates overlap
     */
    static dateOverlaps(firstStartDate: Date, firstEndDate: Date, secondStartDate: Date, secondEndDate: Date): boolean {
        return firstStartDate < secondEndDate && secondStartDate < firstEndDate;
    }
    /**
     * Gets the day of the year (0-365) from a date.
     */
    static dayOfYear(date: Date): number {
        return Math.floor((date.getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000)
    }
    /**
     * @usage
     * ```ts
     * somearray.sort((a, b) => DateUtil.sortChronological(a.startDate, a.endDate, b.startDate, b.endDate));
     * ```
     */
    static sortChronological(firstStartDate: Date, firstEndDate: Date, secondStartDate: Date, secondEndDate: Date): number {
        const startDiff = firstStartDate.getTime() - secondStartDate.getTime();

        if (startDiff != 0)
            return startDiff;

        return firstEndDate.getTime() - secondEndDate.getTime();
    }

    static millisecondsToDays(ms: number): number {
        return ms / 86400000;
    }
}